//#region package.json
var version = "1.6.13";
//#endregion
export { version };
